import React, { useState } from "react";
import { Select } from "@arco-design/web-react";

import "react-csv-importer/dist/index.css";
import AddDropdownFooter from "../AddDropdownFooter";


const Option = Select.Option;


export default function SubscriptionSelector({
    disabled, selectedSubscriptions, setSelectedSubscriptions, allContactListItems, prompt, onAddNew
}) {

    // MUI Autocomplete (multiple) + Chip + TextField -> Arco multiple Select.
    // The component stores full contact-list objects; Arco's onChange passes the
    // selected values (here item.id), so we reconstruct the objects from
    // allContactListItems to preserve the existing data contract.
    const selectedIds = (selectedSubscriptions || []).map((option) => option.id);

    // When an inline "add new list" action is provided we control the dropdown's
    // visibility, so clicking the footer can close it before the dialog opens.
    const [open, setOpen] = useState(false);

    const renderDropdown = (menu) => (
        <div>
            {menu}
            <AddDropdownFooter label="New list" onClick={() => { setOpen(false); onAddNew(); }} />
        </div>
    );

    return (
        <div style={{ width: 500 }}>
            <div style={{ fontSize: 12, color: "var(--color-text-3)", marginBottom: 4 }}>
                {(prompt && prompt) || "Subscriptions"}
            </div>
            <Select
                mode="multiple"
                disabled={disabled}
                id="contact-lists-selector"
                value={selectedIds}
                onChange={(ids) => {
                    const next = ids
                        .map((id) => allContactListItems.find((option) => option.id === id))
                        .filter(Boolean);
                    setSelectedSubscriptions(next);
                }}
                style={{ width: "100%" }}
                placeholder="Select contact list"
                allowClear
                {...(onAddNew
                    ? { popupVisible: open, onVisibleChange: setOpen, dropdownRender: renderDropdown }
                    : {})}
            >
                {allContactListItems.map((option) => (
                    <Option key={option.id} value={option.id}>
                        {(option && option.name) || ""}
                    </Option>
                ))}
            </Select>
        </div>
    )
}
